import WindowModal from './WindowModal';
import {
  ContentProviderAjaxDjangoFetch,
  RESPONSE_JSON_WITH_HTML,
} from '../lib/modals/content_providers/ContentProviderAjax';
import { windowGalleryCarousel } from '../carousels';

class GalleryCarouselModal extends WindowModal {
  constructor(ajaxUrl) {
    super(
      new ContentProviderAjaxDjangoFetch(
        ajaxUrl,
        { method: 'GET' },
        RESPONSE_JSON_WITH_HTML,
      ),
      {
        display_before_content_load: true,
      },
    );
  }

  initContent() {
    super.initContent();
    this.carousels = windowGalleryCarousel();
  }

  // uninitContent() {
  //   super.uninitContent();
  //   this.carousels.forEach(carousel => {
  //     if (carousel !== undefined) {
  //       carousel.destroy();
  //     }
  //   });
  // }
}

export default GalleryCarouselModal;



// WEBPACK FOOTER //
// ./src/js/modals/GalleryCarouselModal.js